import JSInstall from "../../../../contents/docs/integrate/_snippets/install-web.mdx";
import WebSendEvents from "../../../../contents/docs/integrate/send-events/_snippets/send-events-web.mdx";
import PersonProfilesConfig from "../../../../contents/docs/libraries/js/_snippets/person-profiles-config.mdx";
import JSIdentify from "../../../../contents/docs/libraries/js/_snippets/identify.mdx";
import FeatureFlagsLibsIntro from "../../../../contents/docs/libraries/_snippets/feature-flags-libs-intro.mdx";
import WebFeatureFlagsCode from "../../../../contents/docs/integrate/feature-flags-code/_snippets/feature-flags-code-web.mdx";
import BootstrappingIntro from "../../../../contents/docs/feature-flags/snippets/bootstrapping-intro.mdx";
import * as React from 'react';
export default {
  JSInstall,
  WebSendEvents,
  PersonProfilesConfig,
  JSIdentify,
  FeatureFlagsLibsIntro,
  WebFeatureFlagsCode,
  BootstrappingIntro,
  React
};